import { render, staticRenderFns } from "./testPage.vue?vue&type=template&id=04dcd96e&scoped=true"
import script from "./testPage.vue?vue&type=script&lang=js"
export * from "./testPage.vue?vue&type=script&lang=js"
import style0 from "./testPage.vue?vue&type=style&index=0&id=04dcd96e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04dcd96e",
  null
  
)

export default component.exports